import React, { Component } from 'react'
import Header from '../../component/header/header'
import ProductAdv from '../../component/ProductAdv'
import Features from '../../component/ProService/Features'
import RecommondSence from '../../component/ProService/RecommondSence'
import MoreRecommend from '../../component/ProService/more-recommend.jsx'
import scrollTop from '../../utils/scrollTop'
import FuncIntro from './component/func-intro'

import luxianguihua from './img/路线规划/路线规划.jpg'
import waimai from './img/路线规划/推荐场景/外卖.jpg'
import pingche from './img/路线规划/推荐场景/拼车合乘.jpg'
import wuliu from './img/路线规划/推荐场景/物流.jpg'
import paidan from './img/路线规划/推荐场景/网约车派单.jpg'
import lujing from './img/function-intro/路径规划.jpg'
import zhineng from '../../img/icon-2/30.智能数据.png'
import gaoxiao from '../../img/icon-2/15.高效开发.png'
import wending from '../../img/icon-2/23.服务稳定.png'

const voiceDesc = '引入神经网络和增强学习技术，推荐合理的行程路线，并采用自研的数据存储和检索架构，服务性能相比广泛使用的A*和CH等经典算法提升超过8倍'

export default class RoutePlanning extends Component {

	constructor(props) {
		super(props)
		this.state = {
			advlist: [
				{
					title: '智能',
					desc: '基于机器学习打造路线召回、排序引擎，相比CH算法，用户路线一致率提升6个百分点',
					icon: zhineng
				},
				{
					title: '高效',
					desc: '单次算路平均耗时小于0.2毫秒，多对多路线规划支持更高效的批量算路',
					icon: gaoxiao
				},
				{
					title: '稳定',
					desc: '脱胎于实际业务，服务稳定，大并发支持和低延时响应得到拼车等业务性的广泛验证',
					icon: wending
				}
			],
			funcList: [
				{
					desc: '根据起点和终点坐标，综合考虑运输效率和驾驶安全，为用户规划最合理的行程路线。支持超高性能的多对多批量算路',
					image: lujing
				},
			],
			recommondSence: [
				{
					name: '网约车派单',
					content: '合理规划司机接驾、送驾路线，提升交通系统综合运力。注重驾驶安全，避开风险路段，保障司乘双方体验和人身安全',
					icon: 'iconwangyuechepaidan',
					bg: paidan
				},
				{
					name: '拼车合乘',
					content: '利用路线规划和批量算法，寻找最佳合乘方案，提高拼成率，降低绕路距离，降低接送等待时间',
					icon: 'iconpinchehecheng',
					bg: pingche
				},
				{
					name: '外卖',
					content: '利用高性能批量算法功能，规划配送员到店铺和用户的接送顺序和路线，系统性提升整体效率',
					icon: 'iconwaimai',
					bg: waimai
				},
				{
					name: '物流',
					content: '利用路线规划，寻找高速费和运输时间的平衡，避开安全隐患，获得最佳运输效率',
					icon: 'iconwuliu',
					bg: wuliu
				},
			],
			more: [
				{
					name: '智能定位',
					path: '/intelPosition'
				},
				{
					name: '行程时间预估',
					path: '/travelTime'
				}
			]
		};
	}

	componentWillMount() {
		scrollTop()
	}

	render() {
		return (
			<div>
				<Header headerImg={luxianguihua} title={'路线规划'} desc={voiceDesc} />

				<FuncIntro funcList={this.state.funcList} />

				<ProductAdv advList={this.state.advlist} />

				<RecommondSence recommondSence={this.state.recommondSence} />

				<MoreRecommend more={this.state.more} />
			</div>
		)
	}
}
